export const RESET_PASSWORD_FORM_STRINGS = {
  title: 'Reset Password',
  description: 'Enter your new password below. Make sure it meets the security requirements.',
  passwordLabel: 'New Password',
  passwordRequired: 'Password is required',
  confirmPasswordLabel: 'Confirm New Password',
  confirmPasswordRequired: 'Please confirm your password',
  passwordsDoNotMatch: 'Passwords do not match',
  updatePasswordButton: 'Update Password',
  updatingPasswordButton: 'Updating Password...',
  backToLoginButton: 'Back to Login',
} as const
